import { render, staticRenderFns } from "./ModuleType.vue?vue&type=template&id=81c9b508"
import script from "./ModuleType.vue?vue&type=script&lang=js"
export * from "./ModuleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports